export default __webpack_public_path__ + "static/media/features-thumb-2.3f1c7488.png";